import { createFileRoute } from '@tanstack/react-router';
import { LoginPage } from '@/modules/auth/login-page';
import { z } from 'zod';

const loginSearchSchema = z.object({
  redirect: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_public/login')({
  validateSearch: loginSearchSchema,
  component: LoginPage,
});
